import { InputSearchPro } from 'components/InputSearch';
import { empresaToString } from 'utils/padronesToString';
import BusquedaAvanzadaPadrones from 'views/Recaudacion/Caja/BusquedaAvanzadaPadrones';
import { padronesEnum } from '../enums';

const fieldsInfo = {};

const tabs = [
  {
    title: 'Información General',
    fields: [
      'clave_de_control',
      'empresa',
      'giro',
      'categoria_de_giro',
      'aforo',
      'fecha_de_registro_de_licencia',
      'fecha_de_renovacion_de_licencia',
      'zona',
      'sector',
      'inspeccion',
      'dictamen',
      'descripcion_de_actividad',
      'observaciones',
      'estado_del_padron',
    ],
  },
  {
    title: 'Condicionantes',
    fields: [
      'cumple_proteccion_civil',
      'fecha_de_proteccion_civil',
      'cumple_condicion_estructural',
      'fecha_de_condicion_estructural',
      'cumple_licencia_sanitaria',
      'fecha_de_licencia_sanitaria',
      'cumple_aviso_de_funcionamiento',
      'fecha_de_aviso_de_funcionamiento',
      'cumple_uso_de_suelo',
      'fecha_de_uso_de_suelo',
      'uso_de_suelo',
    ],
  },
];

const configs = {
  empresa: {
    advanced: true,
    control: InputSearchPro,
    advancedComponent: BusquedaAvanzadaPadrones,
    advancedComponentProps: { tipoDePadron: padronesEnum.EMPRESA, allowAdd: true, gpm: true },
    advancedComponentName: 'BusquedaAvanzadaPadrones',
    label: 'Empresa',
    tooltip: 'Búsqueda por Razón social',
    resultProps: {
      name: 'empresa',
      label: 'Empresa',
      render: (empresa) => empresaToString(empresa),
    },
    rules: [{ required: true }],
    qName: 'q',
  },
  clave_de_control: {
    formItemProps: {
      label: 'Clave de control',
      required: false,
    },
    controlProps: { disabled: true },
  },
  giro: {
    formItemProps: {
      label: 'Giro de licencia',
      required: true,
    },
  },
  categoria_de_giro: {
    formItemProps: {
      label: 'Categoría De Giro De licencia',
      required: true,
    },
  },
  aforo: {
    formItemProps: {
      label: 'Aforo',
    },
  },
  fecha_de_registro_de_licencia: {
    formItemProps: {
      label: 'fecha de registro de licencia',
      required: true,
    },
    controlProps: { showTime: false },
  },
  fecha_de_renovacion_de_licencia: {
    formItemProps: {
      label: 'Fecha de renovación de licencia',
      required: true,
    },
    controlProps: { showTime: false },
  },
  zona: {
    formItemProps: {
      label: 'Zonificación',
      required: true,
    },
    colProps: { md: 8 },
  },
  sector: {
    formItemProps: {
      label: 'Sector',
      required: false,
    },
    colProps: { md: 8 },
  },
  inspeccion: {
    formItemProps: {
      label: '¿Inspección?',
      required: false,
    },
  },
  dictamen: {
    formItemProps: {
      label: '¿Dictamen?',
      required: false,
    },
  },
  descripcion_de_actividad: {
    formItemProps: {
      label: 'Descripción de actividad',
      required: true,
    },
    controlProps: {
      autoSize: { minRows: 3, maxRows: 3 },
    },
  },
  observaciones: {
    formItemProps: {
      label: 'Observaciones',
    },
    controlProps: {
      autoSize: { minRows: 3, maxRows: 3 },
    },
  },
  estado_del_padron: {
    formItemProps: {
      label: 'Estado del Padrón',
      required: true,
    },
    defaultValue: 2,
    disabledEnAlta: true,
  },
  // condicionantes
  cumple_proteccion_civil: {
    formItemProps: {
      label: '¿Cumple protección civíl?',
      required: false,
    },
  },
  fecha_de_proteccion_civil: {
    formItemProps: {
      label: 'Fecha de protección civíl',
    },
  },
  cumple_condicion_estructural: {
    formItemProps: {
      label: '¿Cumple condición estructural?',
      required: false,
    },
  },
  fecha_de_condicion_estructural: {
    formItemProps: {
      label: 'Fecha de condición estructural',
    },
  },
  cumple_licencia_sanitaria: {
    formItemProps: {
      label: '¿Cumple con fecha de licencia sanitaria?',
      required: false,
    },
  },
  fecha_de_licencia_sanitaria: {
    formItemProps: {
      label: 'Fecha de licencia sanitaria',
    },
  },
  cumple_aviso_de_funcionamiento: {
    formItemProps: {
      label: '¿Cumple con aviso de funcionamiento?',
      required: false,
    },
  },
  fecha_de_aviso_de_funcionamiento: {
    formItemProps: {
      label: 'Fecha de aviso de funcionamiento',
    },
  },
  cumple_uso_de_suelo: {
    formItemProps: {
      label: '¿Cumple con uso de suelo?',
      required: false,
    },
  },
  fecha_de_uso_de_suelo: {
    formItemProps: {
      label: 'Fecha de uso de suelo',
    },
  },
  uso_de_suelo: {
    formItemProps: {
      label: 'Uso de suelo',
    },
  },
};

const forbiddenProps = [];

export default {
  configs,
  forbiddenProps,
  fieldsInfo,
  tabs,
};
